import finsightUrl from '@/finsight/infrastructure/finsightWebUrl';
import URL from '@/finsight/Router/urlConstants';
import { UserPlanType } from '@/users/domain/UserPlan';

export default [
  {
    featureName: 'Recent New Issue Pricing Data',
    url: '',
    info: 'Access a list of most recent Top Issuers, Rating Agencies ' +
          'and Underwriters across parent, industry/subindustry and sector/subsector profile pages.',
    [UserPlanType.STARTER]: false,
    [UserPlanType.PREMIUM]: 'All new issue pricing details',
    [UserPlanType.PRO]: 'All new issue pricing details',
  },
  {
    featureName: 'ABS 15G New Issue Pipeline Data',
    url: `${ finsightUrl.getProductPipelineUrl() }?products=ABS&regions=USOA`,
    [UserPlanType.STARTER]: true,
    [UserPlanType.PREMIUM]: true,
    [UserPlanType.PRO]: true,
  },
  {
    featureName: 'ABS 15G Real-Time Email Alerts',
    url: '',
    info: 'Receive real-time email alerts for ABS 15G filings, a leading ' +
          'indicator of new issue imminently coming to market.',
    [UserPlanType.STARTER]: true,
    [UserPlanType.PREMIUM]: true,
    [UserPlanType.PRO]: true,
  },
  {
    featureName: 'ABS Loan-Level Data (ABS-EE)',
    url: `${ finsightUrl.getProductLoanLevelUrl() }?products=ABS&regions=USOA`,
    [UserPlanType.STARTER]: true,
    [UserPlanType.PREMIUM]: true,
    [UserPlanType.PRO]: true,
  },
  {
    featureName: 'ABS Rating Agency Research',
    url: `${ finsightUrl.getUrl(URL.NRSRO_RESEARCH) }/all?products=ABS&regions=USOA`,
    [UserPlanType.STARTER]: true,
    [UserPlanType.PREMIUM]: true,
    [UserPlanType.PRO]: true,
  },
  {
    featureName: 'ABS StratMaker',
    url: finsightUrl.getUrl('/us-abs-loan-level-data-on-edgar/stratmaker/167899'),
    [UserPlanType.STARTER]: false,
    [UserPlanType.PREMIUM]: true,
    [UserPlanType.PRO]: true,
  },
  {
    featureName: 'League Tables (Underwriter & Rating Agency)',
    url: `${ finsightUrl.getUrl(URL.LEAGUE_TABLE) }/all?products=ABS&regions=USOA`,
    [UserPlanType.STARTER]: false,
    [UserPlanType.PREMIUM]: true,
    [UserPlanType.PRO]: true,
  },
  {
    featureName: 'New Issue Weekly Email Digests ',
    url: '',
    info: 'Receive a weekly recap of the previous week\'s new issue ' +
          'activity every Monday morning.',
    [UserPlanType.STARTER]: false,
    [UserPlanType.PREMIUM]: true,
    [UserPlanType.PRO]: true,
  },
  {
    featureName: 'Bond Screener',
    url: `${ finsightUrl.getUrl(URL.ABS_BONDSCREENER) }?products=ABS&regions=USOA`,
    [UserPlanType.STARTER]: false,
    [UserPlanType.PREMIUM]: false,
    [UserPlanType.PRO]: true,
  },
  {
    featureName: 'BWIC & Inventory Monitor',
    url: `${ finsightUrl.getUrl(URL.BONDS_INVENTORIES_ABS) }?products=ABS&regions=USOA`,
    [UserPlanType.STARTER]: false,
    [UserPlanType.PREMIUM]: false,
    [UserPlanType.PRO]: true,
  },
  {
    featureName: 'BWIC & Inventory Daily Email Digests',
    url: '',
    info: 'Receive a sector-wise summary of live bonds held by dealers' +
          'every morning. For added convenience, we’ve included an excel file ' +
          'containing bond details.',
    [UserPlanType.STARTER]: false,
    [UserPlanType.PREMIUM]: false,
    [UserPlanType.PRO]: true,
  },
  {
    featureName: 'Portfolio Monitor',
    url: `${ finsightUrl.getUrl(URL.PORTFOLIO_MONITOR) }`,
    [UserPlanType.STARTER]: false,
    [UserPlanType.PREMIUM]: false,
    [UserPlanType.PRO]: true,
  },
  {
    featureName: 'TRACE Monitor*',
    url: `${ finsightUrl.getTraceUrl() }?products=ABS&regions=USOA`,
    [UserPlanType.STARTER]: false,
    [UserPlanType.PREMIUM]: false,
    [UserPlanType.PRO]: true,
  },
];
